import * as Migration from 'shared/migration/migration';
import {
  AllFlowsteps, PullFlowsteps, PushFlowsteps, FlowstepType, ErrorReaction,
  toCategory, generateFlowstepName, generateUuid, PullMode,
} from 'shared/utils/flowstep';
import { asArray } from 'shared/utils/utils';


function byType(typeOrTypes) {
  return (flowstep, isMigratingUp) => asArray(typeOrTypes).includes(flowstep.type);
}

const conversions = [
  {
    version: `1`, rules: [
      { isSuitable: byType(AllFlowsteps), migrateUp: v0Tov1All },
      { isSuitable: byType(PullFlowsteps), migrateUp: v0Tov1Pulls, migrateDown: v1tov0Pulls },
    ]
  },
  {
    version: `2`, rules: [
      { isSuitable: byType(FlowstepType.Report), migrateUp: v1tov2Reports, },
      { isSuitable: byType(PushFlowsteps), migrateUp: v1tov2Pushes },
      { isSuitable: byType(FlowstepType.Soql), migrateUp: v1tov2Soql },
    ]
  },
  {
    version: `3`, rules: [
      { isSuitable: byType(PullFlowsteps), migrateUp: v2tov3Pulls, },
    ]
  },
];


export const CURRENT_VERSION = '3';

export function migrateToTheLatest(flowsteps) {
  return Migration.migrateToTheLatest(flowsteps, conversions);
}

export function migrate(flowsteps, toVersion) {
  return Migration.migrate(flowsteps, conversions, toVersion);
}


function v0Tov1All(flowstep) {
  const { type, options } = flowstep;
  flowstep.id ??= generateUuid();
  flowstep.name ??= generateFlowstepName({ flowstep });
  flowstep.category = toCategory({ type });

  options.lastUpdateTimestampCell ??= '';
  options.errorReaction ??= ErrorReaction.AskUser;
}

function v0Tov1Pulls(flowstep) {
  const { options, dataTable } = flowstep;
  options.createDataTable = dataTable;
  options.useDropdownsForPicklists ??= false;
  delete flowstep.dataTable;
}

function v1tov0Pulls(flowstep) {
  const { options } = flowstep;
  const { createDataTable } = options;
  delete options.createDataTable;
  flowstep.dataTable = createDataTable;
}

function v1tov2Reports(flowstep) {
  flowstep.options.excludedFields ??= [];
}

function v1tov2Pushes(flowstep) {
  flowstep.options.rangeToApply.nonEmptyColumns ??= [-1];
}

function v1tov2Soql(flowstep) {
  const { options } = flowstep;
  const { object, fields } = options;
  options.object = { name: object?.name };
  options.fields = (fields ?? []).map(x => ({ name: x.name }));
  options.showLabels ??= false;
}

function v2tov3Pulls(flowstep) {
  flowstep.options.pullMode ??= PullMode.Overwrite;
}